<div class="wizard" data-testid="mfa-enrolment-wizard">
  <ui-auth-error-banner *ngIf="error" [error]="error"></ui-auth-error-banner>

  <!-- The first enrolment call is in flight; without this the host renders an
       empty card for as long as it takes. -->
  <p class="wizard__lede" *ngIf="loading && !enrolment" data-testid="mfa-wizard-preparing">
    {{ 'settings_security.preparing' | translate }}
  </p>

  <!-- The enrolment never started, so neither step below renders: without
       this the host shows an error banner and nothing to press. -->
  <div class="wizard__actions" *ngIf="error && !enrolment && !loading">
    <ui-button
      type="primary"
      testId="mfa-enrolment-retry"
      [label]="'common.retry' | translate"
      (click)="retry()"
    ></ui-button>
    <button type="button" class="wizard__link" data-testid="mfa-enrolment-give-up" (click)="cancel()">
      {{ 'common.cancel' | translate }}
    </button>
  </div>

  <ng-container *ngIf="step === 'setup' && enrolment">
    <div class="wizard__title">{{ 'settings_security.scan_title' | translate }}</div>
    <p class="wizard__lede">{{ 'settings_security.scan_help' | translate }}</p>

    <!-- Plain [src]: no bypassSecurityTrust* -- a payload the sanitiser
         rejects is a backend encoding bug. Absent when the qrcode wheel is
         missing, hence the secret and URI fallbacks below. -->
    <img
      *ngIf="enrolment?.qr_svg_data_uri"
      class="wizard__qr"
      data-testid="mfa-qr"
      [src]="enrolment.qr_svg_data_uri"
      [alt]="'settings_security.qr_alt' | translate"
    />

    <div class="wizard__secret" *ngIf="enrolment?.secret">
      <span class="wizard__secret-label">{{ 'settings_security.secret' | translate }}</span>
      <code class="wizard__secret-value" data-testid="mfa-secret">{{ enrolment.secret }}</code>
    </div>

    <p class="wizard__lede" *ngIf="enrolment?.provisioning_uri">
      <a
        class="wizard__link"
        data-testid="mfa-provisioning-uri"
        [href]="enrolment.provisioning_uri"
      >
        {{ 'settings_security.open_in_app' | translate }}
      </a>
    </p>

    <p class="wizard__notice">{{ 'settings_security.secret_shown_once' | translate }}</p>

    <div class="wizard__actions">
      <ui-button
        type="primary"
        testId="mfa-scan-next"
        [label]="'common.next' | translate"
        (click)="goToVerify()"
      ></ui-button>
      <button type="button" class="wizard__link" (click)="cancel()">
        {{ 'common.cancel' | translate }}
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="step === 'verify'">
    <div class="wizard__title">{{ 'settings_security.verify_title' | translate }}</div>
    <p class="wizard__lede">
      {{
        (method === 'email'
          ? 'settings_security.verify_help_email'
          : 'settings_security.verify_help_totp'
        ) | translate: { email: enrolment?.masked_email }
      }}
    </p>

    <form
      class="wizard__form"
      [formGroup]="codeForm"
      (ngSubmit)="confirm()"
      (keydown.enter)="onEnterConfirm($event)"
    >
      <ui-form-field
        [id]="'mfa-confirm-code'"
        testId="mfa-confirm-code"
        type="text"
        formControlName="code"
        autocomplete="one-time-code"
        inputMode="numeric"
        [maxLength]="6"
        [label]="'settings_security.code' | translate"
        [errorMessages]="{
          required: 'settings_security.required_code' | translate,
          pattern: 'settings_security.invalid_code_format' | translate
        }"
      ></ui-form-field>

      <div class="wizard__actions">
        <ui-button
          type="primary"
          testId="mfa-confirm"
          [label]="'settings_security.activate' | translate"
          [disabled]="loading"
          [isLoading]="loading"
        ></ui-button>

        <button
          *ngIf="method === 'email'"
          type="button"
          class="wizard__link"
          data-testid="mfa-resend"
          [disabled]="loading || resendWait > 0"
          (click)="resendCode()"
        >
          <ng-container *ngIf="resendWait > 0; else resendNow">
            {{ 'settings_security.resend_in' | translate: { seconds: resendWait } }}
          </ng-container>
          <ng-template #resendNow>
            {{ 'settings_security.resend' | translate }}
          </ng-template>
        </button>

        <button type="button" class="wizard__link" (click)="cancel()">
          {{ 'common.cancel' | translate }}
        </button>
      </div>
    </form>
  </ng-container>
</div>
